// Libraries
import React, { useEffect, useRef, useState } from "react";
import { Markup } from "interweave";
import styled from "styled-components";
// import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

// Icons
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

// Styles
import "./OldConvo.scss";
import { Button } from "react-bootstrap";

export const OldConvoContainer = styled.div`
  overflow-y: auto;
  width: -webkit-fill-available;
  width: -moz-available;
  height: 100%;
  flex: 1 1;
  // &::-webkit-scrollbar {
  //   width: 8px;
  // }

  // &::-webkit-scrollbar-thumb {
  //   background-color: #ada89a;
  //   border-radius: 4px;
  // }

  // &::-webkit-scrollbar-track {
  //   background-color: transparent;
  //   border-radius: 6px;
  // }

  // ::-webkit-scrollbar {
  //   width: 12px;
  // }

  // ::-webkit-scrollbar-track {
  //   -webkit-box-shadow: inset 0 0 6px rgb(71, 207, 222);
  //   border-radius: 10px;
  // }

  // ::-webkit-scrollbar-thumb {
  //   border-radius: 10px;
  //   -webkit-box-shadow: inset 0 0 6px rgb(67, 214, 72);
  // }

  scrollbar-width: thin;
  scrollbar-color: #ada89a transparent;
`;

export const ConvoDiv = styled.div`
  border: 0.5px solid grey;
  padding: 10px;
  border-radius: 15px;
  margin: 2%;

  .copy-icon {
    float: right;
    cursor: pointer;
    display: none;
    opacity: 0.2;
    transition: opacity 0.3s;

    &:hover {
      opacity: 1;
    }
  }

  &:hover .copy-icon {
    display: block;
    opacity: 0.2;
  }
`;
const OldConvo = (props) => {
  const {
    chat,
    // isDataLoading,
    data,
    userInput,
    isEVR,
    sendReport,
    // onSectionChange,
    // maxInput,
  } = props;
  const contentref = useRef();
  // const evrRef = useRef();

  const [hideChat, setHideChat] = useState(
    isEVR
      ? Array.from({ length: chat.length - 1 })
        .fill(false)
        .concat(true)
      : Array.from({ length: chat.length }).fill(true).concat(true)
  );

  useEffect(() => {
    setHideChat(
      isEVR
        ? Array.from({ length: chat.length - 1 })
          .fill(false)
          .concat(true)
        : Array.from({ length: chat.length }).fill(true).concat(true)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chat]);

  // const handleCopyClick = async (text) => {
  //   await navigator.clipboard.writeText(text);
  // };

  const hideResponse = (index) => {
    let hide = [...hideChat];
    hide[index] = !hideChat[index];
    setHideChat(hide);
  };

  useEffect(() => {
    console.log(data)
    contentref.current.scrollIntoView({
      behavior: "smooth",
      block: "end",
      inline: "nearest",
    });
    contentref.current.focus();
  }, [data]);

  const renderUserInfo = (user, index) => {
    return (
      <div className="user-info">
        <div
          className="user-info-details"
          onClick={() => isEVR && hideResponse(index)}
        >
          <span className="d-flex w-100">Query: {user.question}</span>
        </div>
        {isEVR && (
          <div onClick={() => hideResponse(index)}>
            {hideChat[index] ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </div>
        )}
        {/* <div
          className="copy-icon"
          onClick={() =>
            handleCopyClick(
              `Query:${user.question}\n  Response:${
                user.response || user.answer
              }`
            )
          }
        >
          {hideChat[index] && (
            <ContentCopyOutlinedIcon style={{ width: "20px" }} />
          )}
        </div> */}
      </div>
    );
  };
  const renderMarkup = (response) => {
    return (
      <Markup
        content={
          `Response:` +
          response
            .split("\n")
            .map((str) =>
              str.replace(
                /(https?:\/\/[^\s]+)/g,
                '<a href="$1" target="_blank" class="highlight-link">$1</a>'
              )
            )
            .join("<br>")
        }
      />
    );
  };



  const Table = ({ data }) => {
    if (!data || !data.length) {
      return null; // handle the case when data is not available or empty
    }

    return (
      <div>
        {data.map((table, tableIndex) => (
          <div key={tableIndex}>
            <h2>{table.Table_name}</h2>
            <table style={{ width: '100%', borderCollapse: 'collapse', margin: '20px 0' }}>
              <thead>
                <tr>
                  {Object.keys(table.Rows[0]).map((column, index) => (
                    <th key={index} style={{ border: '1px solid #dddddd', padding: '8px', textAlign: 'left' }}>
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {table.Rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {Object.keys(row).map((column, columnIndex) => (
                      <td key={columnIndex} style={{ border: '1px solid #dddddd', padding: '8px', textAlign: 'left' }}>
                        {row[column]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    );
  };


  const formatDateAndTime = (dateTime) => {
    const currentDate = new Date(dateTime);

    const year = currentDate.getFullYear().toString();
    const month = padZero(currentDate.getMonth() + 1);
    const day = padZero(currentDate.getDate());
    const hours = padZero(currentDate.getHours());
    const minutes = padZero(currentDate.getMinutes());
    const seconds = padZero(currentDate.getSeconds());

    const date = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return date;
  };

  const padZero = (value) => {
    return value.toString().padStart(2, "0");
  };
  const renderEVR = (txt, index) => {
    return (
      <ConvoDiv
        key={index}
        className={`old-chat ${
          // hideChat[index] && (chat.length === 1 || chat.length < 3)
          //   ? "evr-chat-full"
          //   : chat.length > 2 && hideChat[index]
          //   ? "evr-chat"
          //   : "h-10"
          hideChat[index] ? "evr-chat-full" : "h-10"
          }`}
      >
        {renderUserInfo(txt, index)}
        {hideChat[index] && (
          <>
            <div
              className={`response-container ${isEVR ? "evr-response" : ""}`}
            >
              {renderMarkup(
                txt.response.concat(
                  txt.references
                    ? txt.references.concat(
                      "\n Timestamp: ".concat(
                        formatDateAndTime(txt.executed_at)
                      )
                    )
                    : "\n Timestamp: ".concat(
                      formatDateAndTime(txt.executed_at)
                    )
                )
              )}
            </div>

            <div className="d-flex justify-content-end pt-3">
              {/* <div className="pr-3" style={{ width: "4em" }}>
                <input
                  min={0}
                  max={maxInput}
                  type="number"
                  className="w-100 h-100"
                  onChange={onSectionChange}
                />
              </div> */}
              <Button onClick={() => sendReport(txt)}>Add to report</Button>
            </div>
          </>
        )}
      </ConvoDiv>
    );
  };
  const renderChat = (txt, index) => {
    return (
      <ConvoDiv key={index} className="old-chat">
        {renderUserInfo(txt, index)}
        <div className="text-left">{renderMarkup(txt.response)}</div>
      </ConvoDiv>
    );
  };
  return (
    <OldConvoContainer className={`${isEVR ? "old-convo-container" : "h-100"}`}>
      {chat.map((txt, index) => {
        if (
          (txt.response !== "" && txt.response !== undefined) ||
          (txt.answer !== "" && txt.answer !== undefined)
        ) {
          return isEVR ? renderEVR(txt, index) : renderChat(txt, index);
        } else {
          return (
            <ConvoDiv key={index}>
              <div className="text-left">Query: {txt.question}</div>
              <div className="text-left">Something went wrong</div>
            </ConvoDiv>
          );
        }
      })}
      <div ref={contentref}>
        {data !== "" && data !== null && (
          <ConvoDiv>
            {userInput && (
              <div className="text-left">
                <b>Query:</b> {userInput}
              </div>
            )}
            <span />
            {data && (
              <div className="text-left">
                <b>Response: </b>
                <Markup content={data?.result[0]} />
                <div style={{ marginBottom: '40px', marginTop: '40px' }} >
                  <img src={`data:image/jpeg;base64,${data.image}`} alt="From Flask" />
                </div >
                <Table data={data?.table} />
                <Markup content={data?.result[1]} />
                <Button>Get analysis</Button>
              </div>
            )}
          </ConvoDiv>
        )}
      </div>
    </OldConvoContainer >
  );
};

export default OldConvo;
